import { useMutation, useQueryClient } from '@tanstack/react-query'
import { GcpCertRequest } from '../../types/gcpCert'
import api from '../../api'

const useCreateNewGcpCert = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (gcpCert: GcpCertRequest) => {
      return api.gcpCerts.createNewCert(gcpCert)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gcpCerts'] })
    }
  })
}

export default useCreateNewGcpCert
